export default {
    ADD_ONE    : "TOAST_MESSAGES/ADD_ONE",
    REMOVE_ONE : "TOAST_MESSAGES/REMOVE_ONE",
    OPEN_ONE   : "TOAST_MESSAGES/OPEN_ONE"
};
